import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CabinetShelfRefDto, FiscalFileLocationDto} from '@cradua/data';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';


@Component({
  selector: 'cradua-cabinet-shelf-ref-container',
  templateUrl: './cabinet-shelf-ref-container.component.html',
  styleUrls: ['./cabinet-shelf-ref-container.component.scss']
})
export class CabinetShelfRefContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  fiscalfilelocations$: Observable<FiscalFileLocationDto[]>;
  cabinetshelfrefs$: Observable<CabinetShelfRefDto[]>;
  loading: boolean;
  isLoadingFiscalFileLocation$: Observable<boolean>;
  isLoadingCabinetShelfRef$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingFiscalFileLocation$ = this.gatwayFacade.isLoadingGateway('FiscalFileLocation');
    this.isLoadingCabinetShelfRef$ = this.gatwayFacade.isLoadingGateway(
      'CabinetShelfRef'
    );

    this.fiscalfilelocations$ = this.gatwayFacade.loadGateway('FiscalFileLocation');
    this.cabinetshelfrefs$ = this.gatwayFacade.loadGateway('CabinetShelfRef');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteCabinetShelfRef(deletedValue: any) {
    this.gatwayFacade.remove('CabinetShelfRef', deletedValue);
  }

  // this method control both the create and update
  onSubmitCabinetShelfRef(formValue: any) {
    console.log('form',formValue);
    const pullData = formValue.CabinetShelfRefs;
    console.log('pull',pullData);

    // declare two empty array to hold update and create data
    const allUpdates = [];
    const addAllCabinetShelfRef = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id) {
        allUpdates.push(pullData[i]);
      } else {
        addAllCabinetShelfRef.push(pullData[i]);
      }
    }

    // check if the addAllCabinetShelfRef array is not empty, then dispatch the data to the store
    if (addAllCabinetShelfRef.length > 0) {
      this.gatwayFacade.add('CabinetShelfRef', addAllCabinetShelfRef);
    }

    // dispatch update data to the store
    if (allUpdates.length > 0) {
      this.gatwayFacade.update('CabinetShelfRef', allUpdates, ['id']);
    }
  }
}
